import React from 'react';
import { Checkbox } from '@mui/material';
import { NoItemsYet, TextRow } from 'components';
import { goalsChooseLibraryTargetsNotYet } from './constants';

/** The targets of one library goal in the "Choose from Library" picker, each with its own checkbox. */
export const GoalsFromLibraryTargets = ({ goal, selectedMap, toggleTarget }) => {
    const picked = selectedMap.get(goal?.id);

    if (!goal?.targets?.length) {
        return (
            <div className="targets-tab-details-wrapper">
                <NoItemsYet
                    image={goalsChooseLibraryTargetsNotYet.image}
                    text={goalsChooseLibraryTargetsNotYet.title}
                    subTitle={goalsChooseLibraryTargetsNotYet.subTitle}
                    containerStyles={{ position: 'static' }}
                    height="fit-content"
                />
            </div>
        );
    }

    return (
        <div className="targets-tab-details-wrapper">
            <div className="targets-tab-details-block">
                {goal.targets.map((target, index) => (
                    <div className="targets-tab-details-item-row" key={target.id ?? index}>
                        <Checkbox
                            checked={picked?.has(target.id) || false}
                            onChange={(e) => toggleTarget(goal, target.id, e.target.checked)}
                            disabled={!!goal?.alreadyAdded}
                            name={'checkBox'}
                            style={{ padding: 16, color: goal?.alreadyAdded ? undefined : '#0C66E4' }}
                        />

                        <div className="targets-tab-details-item-cell" style={{ width: 'fit-content' }}>
                            {index + 1}
                        </div>

                        <div className="targets-tab-details-item-cell" style={{ width: '25%' }}>
                            <TextRow name={target?.name} />
                        </div>

                        <div className="targets-tab-details-item-cell" style={{ width: '69%' }}>
                            <TextRow name={target?.description} />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
